import React from 'react';
import LegalLayout, { Section } from '../components/LegalLayout';

const Safety = () => (
  <LegalLayout title="Safety And Responsible AI" effectiveDate="February 1, 2026">
    <Section title="1. Purpose">
      <p>
        YOVAI LLC ("YOVAI", "we", "us") provides managed artificial intelligence communication
        systems that answer inbound calls, qualify customers, schedule appointments, and follow up.
        This document explains how YOVAI is deployed, monitored, and constrained so that its
        automation operates safely inside a client's approved procedures.
      </p>
    </Section>

    <Section title="2. Client-Approved Operation">
      <p>
        Every YOVAI deployment operates using client-approved business knowledge, scheduling logic,
        escalation rules, and communication boundaries. YOVAI does not answer questions or take
        actions that fall outside the material a client has provided and approved during onboarding
        and ongoing configuration.
      </p>
    </Section>

    <Section title="3. AI Disclosure">
      <p>
        Callers and message recipients are informed at the start of an interaction that they may be
        interacting with an AI-powered assistant. YOVAI honors requests to be transferred to a
        human, subject to the transfer rules configured by the client.
      </p>
    </Section>

    <Section title="4. Scope Limits">
      <p>
        YOVAI does not provide professional, medical, legal, safety, financial, or technical
        diagnoses. Sensitive and urgent situations are routed to the client's approved escalation
        procedure, which may include transferring to a human, sending an urgent internal
        notification, or providing a client-approved fallback response.
      </p>
    </Section>

    <Section title="5. Human Oversight">
      <p>
        Prior to going live, every YOVAI deployment is tested against a defined matrix of
        scenarios, including standard inquiries, scheduling, rescheduling, after-hours calls,
        transfer requests, out-of-area customers, unknown questions, and urgent-language
        escalation. The client reviews and approves the deployment before live customer traffic is
        introduced.
      </p>
      <p>
        After launch, YOVAI's performance is monitored by the YOVAI team. Scripts, workflows, and
        handoff rules can be adjusted in response to real-world call activity and client feedback.
      </p>
    </Section>

    <Section title="6. Data Handling">
      <p>
        Personal information captured during calls and messages is used to fulfill the client's
        customer-service purpose (for example, scheduling an appointment or routing a request).
        YOVAI processes this information under the terms of our Privacy Policy and Data Processing
        Addendum.
      </p>
      <p>
        YOVAI does not sell personal information collected on behalf of clients. Retention periods
        and access controls are described in the Data Processing Addendum.
      </p>
    </Section>

    <Section title="7. Responsible Messaging">
      <p>
        YOVAI operates within U.S. telecommunications and messaging regulations, including
        applicable requirements for consent, opt-out, and business messaging registration. Details
        for SMS handling are described in the SMS Terms.
      </p>
    </Section>

    <Section title="8. Reporting Concerns">
      <p>
        If a caller, client, or member of the public believes that a YOVAI-powered interaction has
        behaved in a way that is unsafe, incorrect, or outside the client's approved procedures,
        the concern should be sent to <a href="mailto:yovel@yovaiagency.com">yovel@yovaiagency.com</a>.
        We review reports and, when appropriate, adjust the affected deployment.
      </p>
    </Section>

    <Section title="9. Continuous Improvement">
      <p>
        YOVAI reviews its safety practices, escalation procedures, and testing matrix on a
        recurring basis. Updates to this document reflect changes in our platform, our clients'
        operating procedures, and the regulatory environment in which YOVAI operates.
      </p>
    </Section>
  </LegalLayout>
);

export default Safety;
